'use client'

import { useEffect } from 'react'

// Loads the [data-mock] marker styles in development only, so surfaces that
// still run on mock data are visibly flagged. NODE_ENV is inlined at build
// time, so production bundles drop the import entirely.
export function DevMockStyles() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      import('@/app/dev-mock.css')
    }
  }, [])
  return null
}
